import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

import { Icon } from "@material-ui/core";

import SideBar from "../../../../Components/Sidebar/SideBar";

export default function RolePage() {
  return (
    <>
      <SideBar>
        <div className="d-flex flex-column">
          {/* Begin::Head */}
          <div className="text-center">
            <h2 className="welcomeC">Welcome to equipbid</h2>
          </div>
          <div className="b-15 mb-lg-0 flex-column-auto text-center pb-10"></div>
          <div className="signUpSellerBuyer">
            <Row className="justify-content-center">
              <Col md="5">
                <Link
                  to={{
                    pathname: "/auth/registration",
                    state: { joinWorkView: true },
                  }}
                >
                  <Card>
                    <Card.Body>
                      <div className="text-center">
                        <Icon className="fa fa-briefcase" />
                      </div>
                      <h3>I am a Seller</h3>
                      <p>
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry.
                      </p>
                    </Card.Body>
                  </Card>
                </Link>
              </Col>

              <Col md="5">
                <Link to="/auth/registration">
                  <Card>
                    <Card.Body>
                      <div className="text-center">
                        <Icon className="fa fa-user" />
                      </div>
                      <h3>I am a Buyer</h3>
                      <p>
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry.
                      </p>
                    </Card.Body>
                  </Card>
                </Link>
              </Col>
            </Row>
          </div>
        </div>
      </SideBar>
    </>
  );
}
